<div class="display-flex gap-0-5em flex-align-center">
  <ng-content select="[title]"></ng-content>
  <ng-container [ngSwitch]="opened">
    <mat-icon *ngSwitchCase="true" (click)="onToggle()">keyboard_arrow_up</mat-icon>
    <mat-icon *ngSwitchCase="false" (click)="onToggle()">keyboard_arrow_down</mat-icon>
  </ng-container>
</div>
<ng-container *ngIf="opened">
  <ng-content select="[content]"></ng-content>
</ng-container>
